import React, { useState } from 'react';
import stratagemsData from '../Data/stratagemsData.json';

const Stratagems = () => {
    const [searchQuery, setSearchQuery] = useState('');

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value.toLowerCase());
    };

    const parseDescription = (description) => {
        if (!description) return {};
        const parts = description.split(/(WHEN:|TARGET:|EFFECT:)/).filter(Boolean);
        const parsed = {};
        for (let i = 0; i < parts.length; i += 2) {
            if (parts[i + 1]) {
                parsed[parts[i].replace(':', '').trim()] = parts[i + 1].trim();
            }
        }
        return parsed;
    };

    const groupStratagems = (stratagems) => {
        return stratagems.reduce((groups, strat) => {
            let groupKey;
            if (strat.type.startsWith('Boarding Actions')) {
                groupKey = 'Boarding Actions';
            } else if (strat.type.startsWith('Core')) {
                groupKey = 'Core';
            } else {
                groupKey = strat.detachment || strat.type.split(' - ')[0];
            }
            if (!groups[groupKey]) {
                groups[groupKey] = [];
            }
            groups[groupKey].push(strat);
            return groups;
        }, {});
    };

    const filteredStratagems = stratagemsData.filter((strat) =>
        JSON.stringify(strat).toLowerCase().includes(searchQuery)
    );

    const groupedStratagems = groupStratagems(filteredStratagems);

    return (
        <div className="space-y-4 mt-4">
            <input
                type="text"
                placeholder="Search stratagems..."
                value={searchQuery}
                onChange={handleSearchChange}
                className="w-full px-4 py-2 mb-4 border rounded"
            />
            {Object.keys(groupedStratagems).length > 0 ? (
                Object.keys(groupedStratagems).map((group, index) => (
                    <div key={index}>
                        <h2 className="font-bold text-lg">{group}</h2>
                        {groupedStratagems[group].map((strat, stratIndex) => {
                            const parsedDescription = parseDescription(strat.description);
                            return (
                                <details key={stratIndex} className="rounded bg-slate-100 group">
                                    <summary className="flex items-center gap-1 p-5 font-bold list-none">
                                        <h3 className="capitalize">{strat.name.toLowerCase()} ({strat.cp_cost}CP)</h3>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5 transition group-open:rotate-180">
                                            <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                                        </svg>
                                    </summary>

                                    <div className="px-5 pb-5 space-y-3 text-xs">
                                        <p className="-mt-2 capitalize"><strong>Type:</strong> {strat.type.toLowerCase()}</p>
                                        <p><strong>Turn:</strong> {strat.turn}</p>
                                        <p><strong>Phase:</strong> {strat.phase}</p>
                                        {parsedDescription.WHEN && <p><strong>WHEN:</strong> {parsedDescription.WHEN}</p>}
                                        {parsedDescription.TARGET && <p><strong>TARGET:</strong> {parsedDescription.TARGET}</p>}
                                        {parsedDescription.EFFECT && <p><strong>EFFECT:</strong> {parsedDescription.EFFECT}</p>}
                                    </div>
                                </details>
                            );
                        })}
                    </div>
                ))
            ) : (
                <div>No stratagems found</div>
            )}
        </div>
    );
};

export default Stratagems;